import { Validator } from '@vista-digital/validator';
export const defaultOccShowtimeDisplayText = {
    soldOutLabel: 'SOLD OUT'
};
export const occShowtimeDisplayTextValidator = Validator.object({
    soldOutLabel: Validator.nonEmptyString
});
//# sourceMappingURL=showtime.js.map